import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { BodyPrimary, H2 } from '@liveauctioneers/hammer-ui-core/text';

import { useAppDispatch } from '@/redux/hooks';
import { EventContext } from '@/redux/modules/analytics';
import { CompleteAccountModalContext, openLoginModal } from '@/redux/modules/modal';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export const SearchSignInInterstitial = () => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();

    const handleSignInClick = () => {
        dispatch(
            openLoginModal({
                eventContext: EventContext.join,
                type: CompleteAccountModalContext.Login,
            })
        );
    };

    return (
        <div className="flex flex-col items-center border border-border-secondary py-2xl text-center">
            <H2 className="mb-xs">{formatMessage(['searchPage', 'signInRequired', 'title'])}</H2>
            <BodyPrimary className="mb-md">{formatMessage(['searchPage', 'signInRequired', 'body'])}</BodyPrimary>
            <Button onClick={handleSignInClick}>{formatMessage(['searchPage', 'signInRequired', 'signIn'])}</Button>
        </div>
    );
};
